import xlsx from 'xlsx'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

function exportExcel(data, tableName) {
  const resultWs = xlsx.utils.json_to_sheet(data)
  const wb = xlsx.utils.book_new()

  xlsx.utils.book_append_sheet(wb, resultWs, '-')
  xlsx.writeFile(wb, `${tableName}.xlsx`)
}

function exportJSON(data, fileName) {
  const jsonStr = JSON.stringify(data)
  const blob = new Blob([jsonStr], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  saveAs(url, fileName)
}

function resetForm(parseForm, originalForm) {
  Object.keys(parseForm).map((key) => {
    parseForm[key] = originalForm[key]
    return
  })
}

const readExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const data = e.target.result
      const workbook = xlsx.read(data, { type: 'binary' })
      const firstSheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[firstSheetName]
      const jsonData = xlsx.utils.sheet_to_json(worksheet)
      resolve(jsonData)
    }
    reader.onerror = (e) => {
      reject()
      console.log(e)
    }
    reader.readAsBinaryString(file)
  })
}

function readJsonFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      try {
        const jsonObj = JSON.parse(event.target.result)
        resolve(jsonObj)
      } catch (e) {
        reject()
        console.error('Error parsing JSON:', e)
      }
    }
    reader.onerror = (e) => {
      reject()
      console.error(e)
    }
    reader.readAsText(file)
  })
}

async function downloadFilesAsZip(fileUrls, name) {
  const zip = new JSZip()

  await Promise.all(
    fileUrls.map(async (url) => {
      const response = await fetch(url)
      const blob = await response.blob()
      const filename = url.split('/').pop()
      zip.file(filename, blob)
    })
  )
  const content = await zip.generateAsync({ type: 'blob' })
  return saveAs(content, `${name}.zip`)
}

const localeConfig = {
  en: 'en',
  zh: 'zh',
  hi: 'hi',
  es: 'es',
  de: 'de',
  fr: 'fr',
  ja: 'ja',
  ko: 'ko',
  pt: 'pt',
  ru: 'ru'
}

const i18nConfig = {
  defaultLocale: localeConfig.en,
  locales: Object.values(localeConfig)
}

export {
  exportExcel,
  resetForm,
  downloadFilesAsZip,
  exportJSON,
  readExcelFile,
  readJsonFile,
  localeConfig,
  i18nConfig
}
